export default { sha: '6120ce2cf24dce8285f5b9a8802420b87e04f5a7', buildNumber: 'undefined' }
